import { scrumIntro, learningObjectivesIntro, activitiesListIntro, standardActivities, standardActivitiesClosing, estimated, closing } from './AL00000Sprint00'
import { internalLink, externalLink } from '../DataAndAPIs/Links'
import { gettingToKnowEachOtherLink } from '../Activities/WebGettingToKnowEachOther'
import { toolsOfTheTradeLink } from '../Activities/ToolsOfTheTrade'
import { htmlLink } from '../Activities/HTML'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'

export const al44000Sprint01 = (classSectionID, sprint) => {
	return ( <div>
		<h5>Sprint 1: {getModuleDescription(sprint-1)}</h5>
		
		<p><em>Welcome to Software Engineering!</em> By this point in your software development journey I’m sure you are 
		confident in writing moderately complicated software programs. You’ve learned about structured programming techniques 
		like sequence, selection, and repetition. You've learned how to break complicated programs down into more manageable 
		pieces by using functions and classes. You even understand how object-oriented programming can help you effectively 
		develop more complex applications by utilizing encapsulation, inheritance, and polymorphism.</p>

		<p>That’s wonderful, however to create modern sophisticated software products we need to master additional skills that 
		allow us to effectively work in and across teams to predictably develop, enhance, and maintain complex systems that 
		meet real users needs. These additional Software Engineering skills are included in what we call the Software 
		Development Life Cycles (SDLCs) and include topics like project management, application architecture, requirements, testing, 
		support, and maintenance. These are some of the topics that we will be exploring as part of this Software Engineering 
		course.</p>

		{scrumIntro(classSectionID, sprint)}

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Effectively participate as part of a Scrum team and in a blended classroom environment</li>
			<li>Compare and contrast leading Software Development Life Cycles (SDLCs)</li>
			<li>Explain why agile development and Scrum have become the preferred software development process</li>
			<li>Describe software as a service and cloud computing</li>
			<li>Utilize leading developer tools to create and update software applications</li>
		</ul>

		{list44000Sprint01(sprint)}
		{closing(sprint)}
	</div> )
}

export const list44000Sprint01 = (sprint) => {
	const engineeringSoftwareAsAService = () => externalLink('Engineering Software as a Service','http://www.saasbook.info/')
	const prefaceLecture = () => internalLink('lecture', '/activity-video/preface')
	const sdlcLecture = () => internalLink('Software Development Life Cycles lecture', '/activity-video/software-development-life-cycles')
	const soaLecture = () => internalLink('Service Oriented Architecture lecture', '/activity-video/service-oriented-architecture')
	const cloudComputingLecture = () => internalLink('Cloud Computing lecture', '/activity-video/cloud-computing')

	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, gettingToKnowEachOtherLink())}
			<li>Read {engineeringSoftwareAsAService()} Preface and review associated {prefaceLecture()}</li>
			<li>Read {engineeringSoftwareAsAService()} Chapter 1</li>
			<li>Review the {sdlcLecture()}</li>

			<li>Submit your initial Discussion {sprint} post by the middle of the sprint</li>
			<li>Review the {soaLecture()}</li>
			<li>Complete {htmlLink()} - Part 1 and Part 2{estimated('2 hours')}</li>
			<li>Review the {cloudComputingLecture()}</li>
			<li>Complete {toolsOfTheTradeLink()}</li>

			{standardActivitiesClosing(sprint, gettingToKnowEachOtherLink(), '6 hours')}
		</ol>
	</div> )
}

// Certified for FA26 on August 21, 2025
// Copy activity about Git Commands from sprint 2 to sprint 1. 



